import * as React from 'react';

import { reduceStyles } from '@/helpers';
import { ViewProps } from './model';
import './style.css';

const View: React.FC<ViewProps> = ({ children, style }) => {
	const styleObject = reduceStyles(style as object);

	return (
		<div style={styleObject as React.CSSProperties} className='baseComponent'>
			{children}
		</div>
	);
};

export default View;
